import React, { FC } from 'react'

import { motion } from 'motion/react'
import { createPortal } from 'react-dom'

import styles from './SnapOverlay.module.scss'
import { SnapOverlayProps } from './SnapOverlay.types'

export const SnapOverlay: FC<SnapOverlayProps> = ({ rect, isDragging }) => {
  if (!rect) return null
  return createPortal(
    <motion.div
      className={styles.snapOverlay}
      initial={{ opacity: 0 }}
      animate={{
        left: rect.x,
        top: rect.y,
        width: rect.width,
        height: rect.height,
        opacity: isDragging ? 1 : 0
      }}
      transition={{ type: 'spring', stiffness: 400, damping: 35 }}
    />,
    document.body
  )
}
